var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notification",class:'is-' + _vm.level},[(_vm.closable)?_c('button',{staticClass:"delete",attrs:{"aria-hidden":"true","data-dismiss":"alert","title":"Close","type":"button"},on:{"click":function($event){return _vm.close()}}}):_vm._e(),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.message)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }